import {
	MaterialTypeObject,
	MaterialRequestResults,
	IMaterialRequestReasonObject,
	MaterialRequest,
} from '../../interfaces/Material.Interface';
import { GetQueryId } from '../../interfaces/Ordel.Interface';
import { api } from '../slices/api';

// Define a service using a base URL and expected endpoints
export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		getMaterialRequest: builder.query<
			MaterialRequestResults,
			{
				search?: string;
				order_line_item?: string;
				vendor?: string;
				status?: string;
				building?: string;
				limit?: number;
				ordering?: string;
				offset?: number;
				page?: string;
			} | void
		>({
			query: (args) => {
				if (args) {
					return {
						url: 'material/material-request',
						params: args,
					};
				}
				return 'material/material-request/';
			},
		}),
		getMaterialRequestParams: builder.mutation({
			query: (values) => ({
				url: `material/material-request${values !== '' ? values : ''}`,
			}),
		}),
		getMaterialRequestById: builder.query<MaterialTypeObject[], GetQueryId>({
			query: ({ id }: GetQueryId) => `material/material-request/${id}/`,
		}),
		addMaterialRequest: builder.mutation({
			query: (values) => ({
				url: 'material/material-request/',
				method: 'POST',
				body: values,
			}),
		}),
		updateMaterialRequest: builder.mutation({
			query: ({ id, values }) => ({
				url: `material/material-request/${id}/`,
				method: 'PATCH',
				body: values,
			}),
		}),
		getMaterialRequestReasons: builder.query<
			IMaterialRequestReasonObject[],
			void
		>({
			query: () => {
				return 'material/material-request-reasons/';
			},
		}),
		requestMoreMaterial: builder.mutation({
			query: ({
				id,
				values,
			}: {
				id: string;
				values: Partial<MaterialRequest>;
			}) => ({
				url: `material/material-request/${id}/duplicate/`,
				method: 'POST',
				body: values,
			}),
		}),
		deleteMaterialRequest: builder.mutation({
			query: ({ id }) => ({
				url: `material/material-request/${id}/`,
				method: 'DELETE',
			}),
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetMaterialRequestQuery,
	useLazyGetMaterialRequestQuery,
	useGetMaterialRequestByIdQuery,
	useAddMaterialRequestMutation,
	useUpdateMaterialRequestMutation,
	useGetMaterialRequestParamsMutation,
	useGetMaterialRequestReasonsQuery,
	useRequestMoreMaterialMutation,
	useDeleteMaterialRequestMutation,
} = extendedApiSlice;
